import { IMAGE_BASE } from "./api";

// Các hàm dùng chung về file trong kho ảnh: dựng link, nhận diện loại file,
// định dạng dung lượng và ngày giờ.

const encodeSegments = (path, name) => {
  const segs = [];
  if (path) path.split("/").forEach((s) => s && segs.push(encodeURIComponent(s)));
  if (name) segs.push(encodeURIComponent(name));
  return segs.join("/");
};

// Link ảnh gốc.
export const buildUrl = (path, name) =>
  `${IMAGE_BASE}/images/${encodeSegments(path, name)}`;

// Ảnh thu nhỏ 320px cho lưới hiển thị (máy chủ tự sinh và cache). Chỉ dùng cho
// JPG/PNG: với loại khác máy chủ trả nguyên file gốc.
export const buildThumbUrl = (path, name) =>
  `${IMAGE_BASE}/images/_thumb/${encodeSegments(path, name)}`;

// Link ảnh đã thu nhỏ theo chiều rộng: dán vào web sẽ nhẹ hơn ảnh gốc nhiều.
export const buildSizedUrl = (path, name, width) =>
  `${IMAGE_BASE}/images/_w/${width}/${encodeSegments(path, name)}`;

export const COPY_SIZES = [
  { key: "s", label: "Nhỏ", hint: "480px · ảnh thẻ, danh sách", width: 480 },
  { key: "m", label: "Vừa", hint: "800px · ảnh trong bài viết", width: 800 },
  { key: "l", label: "Lớn", hint: "1600px · ảnh bìa, toàn màn hình", width: 1600 },
];

export const isVideo = (n) => /\.(mp4|mov|avi|mkv|webm|m4v|wmv|flv|3gp)$/i.test(n);
export const isPdf = (n) => /\.pdf$/i.test(n);
// Máy chủ chỉ thu nhỏ JPG/PNG; các loại khác chỉ có link gốc.
export const isResizable = (n) => /\.(jpe?g|png)$/i.test(n);

export const fileKind = (n) => (isPdf(n) ? "pdf" : isVideo(n) ? "video" : "image");

// GIF/WEBP không có bản thu nhỏ: chỉ tải thẳng file gốc vào lưới khi nó đủ nhẹ.
const LIGHT_ORIGINAL_BYTES = 1.5 * 1024 * 1024;
export const canShowInGrid = (item) =>
  isResizable(item.name) || (item.size > 0 && item.size <= LIGHT_ORIGINAL_BYTES);

export const fileExt = (n) => {
  const dot = n.lastIndexOf(".");
  return dot < 0 ? "" : n.slice(dot + 1).toUpperCase();
};

export const formatSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
};

const two = (n) => String(n).padStart(2, "0");

export const formatDay = (ms) => {
  if (!ms) return "";
  const d = new Date(ms);
  return `${two(d.getDate())}/${two(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const formatDateTime = (ms) => {
  if (!ms) return "";
  const d = new Date(ms);
  return `${formatDay(ms)} ${two(d.getHours())}:${two(d.getMinutes())}`;
};

// Mô tả nơi đang dùng một ảnh, theo dữ liệu máy chủ trả về ({ site, lastSeen }).
// lastSeen = 0: máy chủ biết ảnh đang được dùng qua dữ liệu (ví dụ ảnh nằm trong
// bài đăng của app) chứ chưa ghi nhận lượt tải nào.
export const usageText = (used) =>
  used.lastSeen
    ? `${used.site} đang dùng ảnh này (lần tải gần nhất: ${formatDay(used.lastSeen)}).`
    : `Ảnh này đang nằm trong ${used.site}.`;

// Chép chuỗi vào clipboard; trả về true nếu chép được.
export const copyText = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // rơi xuống cách chép dự phòng bên dưới
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  document.body.removeChild(ta);
  return ok;
};
